import { render, staticRenderFns } from "./BaseTimer.vue?vue&type=template&id=36d45e5a&scoped=true&"
import script from "./BaseTimer.vue?vue&type=script&lang=js&"
export * from "./BaseTimer.vue?vue&type=script&lang=js&"
import style0 from "./BaseTimer.vue?vue&type=style&index=0&id=36d45e5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d45e5a",
  null
  
)

export default component.exports